export interface PlatformMicroApp {
  name: 'crest-crm' | 'crest-operations' | 'crest-agent';
  appName: 'crm' | 'operations' | 'agent';
}

const apps: Record<PlatformMicroApp['name'], PlatformMicroApp> = {
  'crest-crm': {
    name: 'crest-crm',
    appName: 'crm',
  },
  'crest-operations': {
    name: 'crest-operations',
    appName: 'operations',
  },
  'crest-agent': {
    name: 'crest-agent',
    appName: 'agent',
  },
};

export function resolveMicroApp(pathname: string): PlatformMicroApp | undefined {
  const path = pathname.toLowerCase();
  if (path === '/app/crm' || path.startsWith('/app/crm/')) return apps['crest-crm'];
  if (path.startsWith('/app/operations') || path.startsWith('/app/reporting')) {
    return apps['crest-operations'];
  }
  if (
    path.startsWith('/app/agent') ||
    path.startsWith('/app/admin/agent') ||
    path.startsWith('/app/admin/agent-config') ||
    path.startsWith('/app/admin/agent-data') ||
    path.startsWith('/app/admin/intelligent-approval') ||
    path.startsWith('/app/admin/approval-management') ||
    path.startsWith('/app/admin/process-integration') ||
    path.startsWith('/app/admin/workbench')
  ) {
    return apps['crest-agent'];
  }
  return undefined;
}

/** 标识由业务 Remote 承载的路径，供 Portal 原生页面门禁排除委托路由。 */
export function isDelegatedMicroAppPath(pathname: string): boolean {
  return Boolean(resolveMicroApp(pathname));
}

export function isMicroAppPublished(name: PlatformMicroApp['name']): boolean {
  return __CREST_DELIVERY_MODE__ === 'mf' && Boolean(apps[name]);
}

/**
 * 应用级导航采用默认拒绝：仅门户原生应用和当前交付引擎已发布的子应用可见。
 * 新业务应用必须先完成主应用注册，不能仅凭后端 sitemap 自动出现在门户中。
 */
export function isPortalAppPublished(appName: string): boolean {
  const normalized = appName.toLowerCase();
  if (normalized === 'admin') return true;
  if (normalized === 'crm') return isMicroAppPublished('crest-crm');
  if (normalized === 'operations' || normalized === 'reporting') {
    return isMicroAppPublished('crest-operations');
  }
  if (normalized === 'agent') return isMicroAppPublished('crest-agent');
  return false;
}

/** 平台原生路由可见；业务路由仅在当前微前端交付引擎中已发布时可见。 */
export function isNavigationPathPublished(pathname: string): boolean {
  const app = resolveMicroApp(pathname);
  if (app) return isMicroAppPublished(app.name);

  const path = pathname.toLowerCase();
  return path === '/app/admin' || path.startsWith('/app/admin/');
}
